import { jsx, Fragment } from "react/jsx-runtime";
import { Children } from "react";
import { SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const OneFourth = ({
  children
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flex: {
            md: `calc(25% - ${SpaceLg})`,
            xs: `calc(50% - ${SpaceMd})`
          },
          maxWidth: {
            md: `calc(25% - ${SpaceLg})`,
            xs: `calc(50% - ${SpaceMd})`
          },
          margin: "2px 0px"
        },
        children: child
      },
      index
    );
  }) });
};
export {
  OneFourth
};
